import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledDomicileAddressCardWrapper = styled(Grid)<{$isOpen: boolean}>(
    ({theme: {palette}}) => css`
        width: 100%;
        border-radius: 6px;
        background-color: ${palette.neutral[50]};
        outline: 1px solid ${palette.neutral[200]};
    `
)

export const StyledDomicileAddressHint = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[950]};
    `
)
